import React, { PropsWithChildren, useEffect, useState } from 'react';
import {
    MappedComponentProperties,
} from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './CardDisclosuresMobileWallet.css';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';
import SessionStorage from '../../utils/SessionStorage';
import axios from 'axios';
import { acquisitionApiRequest } from '../../utils/acquisition-api/AcquisitionApi';
import { usePushdownContext } from '../../providers/Pushdown/PushdownProvider';
import useGenerateAcquisitionsPdf from '../../hooks/useGenerateAcquisitionsPdf';
import { InputCheckbox } from 'component-library/index';
import { Row, Col, Container } from '../../importCL';
interface IInstantIssuanceOffer {

    OfferTypeAccepted?: string;
    IsError: boolean,
    Errors?:
    {
        FieldName: string,
        ErrorMessage: string,
        ErrorType: string
    }
}
export interface ICardDisclosuresMobileWalletProps extends MappedComponentProperties {
    agreementText?: string;
    ctaAgreeText?: string;
    ctaAgreeRedirectPath?: string;
    apiErrorCode?: string;
}

export const CardDisclosuresMobileWalletEditConfig = {
    emptyLabel: 'Card Disclosures Mobile Wallet',
    isEmpty: (props: PropsWithChildren<ICardDisclosuresMobileWalletProps>) => {
        return !props || !props.agreementText;
    },
};

const CardDisclosuresMobileWallet = (
    props: PropsWithChildren<ICardDisclosuresMobileWalletProps>,
): JSX.Element => {

    const { showPushdown } = usePushdownContext();
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const [mwData, setMwData] = useState({
        rewardsLinkPath: '',
        rewardsLinkText: undefined,
        acknowledgmentText: undefined,
        addOnPdf: undefined,
        pdfOptions: undefined,
    });
    const [isAcknowledged, setIsAcknowledged] = useState<boolean>(false);

    const programCode = SessionStorage.get('selectedProgramCode') as string;
    const { generate: generatePdf } = useGenerateAcquisitionsPdf();

    const setInstantIssuanceOffer = async () => {
        const ApplicationId = SessionStorage.tryGet('ApplicationId', null);
        let errorOccurred = false;
        setIsButtonDisabled(true);

        try {
            if (!ApplicationId) {
                throw new Error('ApplicationId not found');
            }

            await acquisitionApiRequest<IInstantIssuanceOffer>('set-instant-issuance-offer', {
                body: {
                    'ApplicationId': ApplicationId,
                    'OfferType': 2,
                },
                method: 'POST',
            });

            window.location.assign(props.ctaAgreeRedirectPath + window.location.search || '');
            return true;
        } catch (err) {
            console.error('CardDisclosuresMobileWallet:', err);
            SessionStorage.set('instantIssuanceOfferError', 'true');
            showPushdown(props.apiErrorCode || '');
            errorOccurred = true;
            return false;
        } finally {
            if (!errorOccurred) {
                setIsButtonDisabled(false);
            }
        }
    };

    useEffect(() => {
        if (!programCode) {
            return;
        }
        
        const getDataFromSessionStorage = async () => {
            const approvedData = await SessionStorage.tryGetCipher('app-approved-data', {});
            const creditLine = parseInt((approvedData?.CreditLine || '').replace(/[^0-9.-]+/g, ''), 10);

            const servletUrl = `/services/mobilewalletv2?programCode=${programCode.toLowerCase()}&creditLine=${creditLine}`;
            axios.get(servletUrl)
                .then((response) => {
                    if (
                        response &&
                        response.data &&
                        response.data.path
                    ) {
                        setMwData({
                            rewardsLinkPath: response.data.path,
                            rewardsLinkText: response.data?.rewardsLinkText,
                            acknowledgmentText: response.data?.acknowledgmentText,
                            addOnPdf: response.data?.addOnPdf,
                            pdfOptions: response.data?.pdfOptions,
                        });
                    } else {
                        showPushdown(props.apiErrorCode || '');
                    }
                })
                .catch((err) => {
                    if (err.status === 404) {
                        // eslint-disable-next-line no-console
                        console.log('No disclosure found for: ' + programCode + ' Error: ' + err);
                    }

                    showPushdown(props.apiErrorCode || '');
                });
        };
        getDataFromSessionStorage();
    }, []);

    useEffect(() => {
        if (SessionStorage.verifyNotEmpty('instantIssuanceOfferError')) {
            showPushdown(props.apiErrorCode || '');
            setIsButtonDisabled(true);
        }
    }, []);

    return (
        <Container id='card-disclosures-mobile-wallet' className='CardDisclosuresMobileWallet'>
            <Row>
                <Col>
                    <p className='CardDisclosuresMobileWallet__agreementText'>
                        {transformHTMLParserLinks(props.agreementText as string)}
                    </p>
                    <div className='CardDisclosuresMobileWallet__defaultRewardsLink'>
                        <a
                            {...(mwData.rewardsLinkPath.includes('.pdf') ? { disabled: !mwData.rewardsLinkPath, 'aria-disabled': !mwData.rewardsLinkPath, href: mwData.rewardsLinkPath, target: '_blank', download: true }
                                : { onClick: () => generatePdf(mwData.addOnPdf, mwData.rewardsLinkPath, mwData.pdfOptions) }
                            )}
                        >
                            {transformHTMLParserLinks(mwData.rewardsLinkText as string)}
                            <svg
                                className='svg-inline--fa fa-file-pdf fa-w-12'
                                aria-hidden='true'
                                data-prefix='fal'
                                width='11px'
                                height='15px'
                                data-icon='file-pdf'
                                role='img'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 384 512'
                                data-fa-i2svg=''
                            >
                                <path
                                    fill='currentColor'
                                    d='M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-22-171.2c-13.5-13.3-55-9.2-73.7-6.7-21.2-12.8-35.2-30.4-45.1-56.6 4.3-18 12-47.2 6.4-64.9-4.4-28.1-39.7-24.7-44.6-6.8-5 18.3-.3 44.4 8.4 77.8-11.9 28.4-29.7 66.9-42.1 88.6-20.8 10.7-54.1 29.3-58.8 52.4-3.5 16.8 22.9 39.4 53.1 6.4 9.1-9.9 19.3-24.8 31.3-45.5 26.7-8.8 56.1-19.8 82-24 21.9 12 47.6 19.9 64.6 19.9 27.7.1 28.9-30.2 18.5-40.6zm-229.2 89c5.9-15.9 28.6-34.4 35.5-40.8-22.1 35.3-35.5 41.5-35.5 40.8zM180 175.5c8.7 0 7.8 37.5 2.1 47.6-5.2-16.3-5-47.6-2.1-47.6zm-28.4 159.3c11.3-19.8 21-43.2 28.8-63.7 9.7 17.7 22.1 31.7 35.1 41.5-24.3 4.7-45.4 15.1-63.9 22.2zm153.4-5.9s-5.8 7-43.5-9.1c41-3 47.7 6.4 43.5 9.1z'
                                ></path>
                            </svg>
                        </a>
                    </div>
                    <InputCheckbox id='CardDisclosuresMobileWallet__acknowledgement'
                        disabled={!mwData.rewardsLinkPath}
                        aria-disabled={!mwData.rewardsLinkPath}
                        name='disclosureAcknowledgement'
                        label={transformHTMLParserLinks(mwData.acknowledgmentText as string)}
                        value={isAcknowledged}
                        setValue={setIsAcknowledged}
                        labelClass='CardDisclosuresMobileWallet__acknowledgementText' />
                </Col>
            </Row>
            <Row>
                <Col className='CardDisclosuresMobileWallet__button'>
                    <ButtonWrapper
                        className='medium'
                        disabled={isButtonDisabled || !isAcknowledged || !mwData.rewardsLinkPath}
                        onClick={() => setInstantIssuanceOffer()}>
                        {transformHTMLParserLinks(props.ctaAgreeText as string)}
                    </ButtonWrapper>
                </Col>
            </Row>
        </Container>
    );
};

export default CardDisclosuresMobileWallet;
